<template>
  <div class="equipment-page">
    <el-row class="bgW">
      <el-col :span="20">
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="所在门店">
            <el-select v-model="search.shop_id" clearable filterable placeholder="请选择门店">
              <el-option
                v-for="s in shopOptions"
                :key="s.value"
                :label="s.label"
                :value="s.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="search.status" clearable placeholder="请选择状态">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
        <el-button size="mini" @click="getList('resetForm')">重置</el-button>
      </el-col>
    </el-row>

    <div class="accountCon">
      <div class="top-bar">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog()">添加设备</el-button>
      </div>
      <el-row>
        <el-col :span="24">
          <el-table :data="list" size="small" :header-cell-style="$style.rowClass" :cell-style="$style.rowClass" border>
            <el-table-column label="ID" prop="id" width="60" align="center" />
            <el-table-column label="设备序列号" prop="device_sn" min-width="160" show-overflow-tooltip />
            <el-table-column label="设备类型" prop="device_model" min-width="130" />
            <el-table-column label="设备名称" prop="name" min-width="140" show-overflow-tooltip />
            <el-table-column label="所在门店" prop="shop_name" min-width="140" show-overflow-tooltip />
            <el-table-column label="绑定时间" prop="create_time" width="170" align="center">
              <template slot-scope="{ row }">{{ row.create_time || '-' }}</template>
            </el-table-column>
            <el-table-column label="状态" width="140" align="center">
              <template slot-scope="{ row }">
                <el-switch
                  v-if="row.status !== undefined"
                  v-model="row.status"
                  :active-value="1"
                  :inactive-value="2"
                  active-text="启用"
                  inactive-text="禁用"
                  @change="handleStatusChange(row)"
                />
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center" fixed="right">
              <template slot-scope="{ row }">
                <el-button type="text" size="mini" @click="openDialog(row)">编辑</el-button>
                <el-button type="text"  size="mini" @click="handleUnbind(row)" v-if="row.shop_id">解绑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.pagesize"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>

    <el-dialog
      :title="form.id ? '编辑设备' : '添加设备'"
      :visible.sync="dialogVisible"
      width="520px"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <el-form ref="formRef" :model="form" label-width="120px" label-suffix="：" size="mini" :rules="rules">
        <el-form-item label="设备序列号" prop="device_sn">
          <el-input v-model="form.device_sn" clearable placeholder="请输入设备序列号" :readonly="form.id" required />
        </el-form-item>
        <el-form-item label="设备类型" prop="device_model">
          <el-input v-model="form.device_model" clearable placeholder="请输入设备类型" />
        </el-form-item>
        <el-form-item label="设备名称" prop="name">
          <el-input v-model="form.name" clearable placeholder="请输入设备名称" />
        </el-form-item>
        <el-form-item label="所在门店" prop="shop_id">
          <el-select v-model="form.shop_id" clearable filterable placeholder="请选择门店" style="width: 100%;">
            <el-option
              v-for="s in shopOptions"
              :key="s.value"
              :label="s.label"
              :value="s.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="submitForm">确认保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/components/Pagination'
import { getDeviceList, createDevice, updateDevice, updateDeviceStatus, unbindDevice } from '@/api/goods'
import { shopPerson } from "@/api/shop";


const EMPTY_FORM = () => ({
  id: null,
  device_sn: '',
  device_model: '',
  name: '',
  shop_id: null
})

export default {
  name: 'EquipmentList',
  components: { pagination },
  data () {
    return {
      search: { shop_id: null, status: null },
      page: { total: 0, page: 1, pagesize: 10 },
      list: [],
      shopOptions: [],
      dialogVisible: false,
      form: EMPTY_FORM(),
      rules: {
        device_sn: [{ required: true, message: '请输入设备序列号', trigger: 'blur' }],
        device_model: [{ required: true, message: '请输入设备类型', trigger: 'blur' }],
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        shop_id: [{ required: true, message: '请选择所在门店', trigger: 'change' }]
      },
      statusList: [
        { label: '启用', value: 1 },
        { label: '禁用', value: 2 }
      ]
    }
  },
  mounted () {
    this.loadShopOptions()
    this.getList()
  },
  methods: {
    loadShopOptions () {
      shopPerson({ action: 'shop' }).then(res => {
        const list = res || []
        this.shopOptions = list.map(s => ({
          value: s.id ,
          label:  s.name 
        }))
      })
    },
    getList (option) {
      if (option === 'resetForm') {
        this.search = { name: '', device_sn: '', shop_id: null, status: null }
        this.page.page = 1
      }
      if (option === 'search') this.page.page = 1
      getDeviceList({ ...this.search, page: this.page.page, pagesize: this.page.pagesize }).then(res => {
        this.list = (res.data && res.data.list) || []
        this.page.total = (res.data && (res.data.dataCount || res.data.total)) || 0
      })
    },
    openDialog (row) {
      if (row) {
        this.form = {
          id: row.id,
          device_sn: row.device_sn || '',
          device_model: row.device_model || '',
          name: row.name || '',
          shop_id: row.shop_id != null ? row.shop_id : null
        }
      } else {
        this.form = EMPTY_FORM()
      }
      this.dialogVisible = true
    },
    resetForm () {
      this.form = EMPTY_FORM()
      this.$refs.formRef && this.$refs.formRef.clearValidate()
    },
    submitForm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        const payload = { ...this.form }
        const req = payload.id ? updateDevice(payload) : createDevice(payload)
        req.then(res => {
          this.$message({ type: 'success', message: res.msg || (payload.id ? '编辑成功' : '添加成功') })
          this.dialogVisible = false
          this.getList('search')
        })
      })
    },
    handleStatusChange (row) {
      updateDeviceStatus({ id: row.id, status: row.status }).then(res => {
        this.$message({ type: 'success', message: res.msg || '状态更新成功' })
      }).catch(() => {
        row.status = row.status === 1 ? 2 : 1
      })
    },
    handleUnbind (row) {
      this.$confirm(`确定解绑设备「${row.name || row.device_sn}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        unbindDevice({ id: row.id }).then(res => {
          this.$message({ type: 'success', message: res.msg || '解绑成功' })
          this.getList()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.bgW {
  background: #fff;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 16px 16px 0;
}
.accountCon {
  background: #fff;
  padding: 10px 0 40px;
}
.top-bar {
  padding: 0 10px 10px;
}
</style>
